module.exports = __webpack_public_path__ + "img/illus-home.3218d85d.png";